// Idempotency keys for online financial submissions (P0 duplicate-transaction hotfix).
export const newIdemKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
export const idemHeaders = (key) => ({ headers: { "Idempotency-Key": key } });
